import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ISizeName } from '@df/core/service/client';
import { MultisiteService } from '@df/core/service/multisite';
import { DfCmsModal } from '@df/ui/modal/df-cms-modal.decorator';
import { NDfModal } from '@df/ui/modal/df-modal.interface';
import { ModalRef } from '@df/ui/modal/modal-ref';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { ModalLayoutMiddleComponent } from '../../../ui/modal/modal-layout-middle.component';
import { BasketTotalModalInitiatorService } from './basket-total-modal-initiator.service';
import { NBasketTotalModal } from './basket-total-modal.interface';
@DfCmsModal({
    id: NBasketTotalModal.BLOCK_ID,
    position: 'custom',
    name: 'Basket Total',
    config: (sizeId: ISizeName) => ({
        closeOnNavigation: true,
        minWidth: undefined,
        maxWidth: undefined,
        width: sizeId === 'S' ? '90vw' : '41.2em',
        modalClass: 'bg-col-w',
        hasBackdrop: false,
        scrollStrategy: 'noop'
    }),
    blockGroup: 'modals',
    priority: 30,
    initiators: [BasketTotalModalInitiatorService],
    reopenPolicy: NDfModal.ReopenPolicy.first,
    sizeRestriction: sizeId => (sizeId === 'S' ? ['S'] : ['M', 'L', 'X']),
    prerenderAllowed: false,
    allowedLocation: /^\/basket$/
})
@ICmsComponent<BasketTotalModalComponent>({
    id: NBasketTotalModal.BLOCK_ID,
    block: {
        url: NBasketTotalModal.BLOCK_ID,
        scope: 'website'
    },
    onDemandOnly: true,
    name: 'Basket Total Popup',
    description: 'Appears when user basket totals reach the goal.',
    fields: [
        <NICmsContentField.IField>{
            key: 'section-content',
            type: NICmsContentField.EFieldType.label,
            title: 'Content'
        },
        <NICmsContentField.IField>{
            key: 'image',
            type: NICmsContentField.EFieldType.image,
            title: 'Image',
            required: true
        },
        {
            key: 'title',
            type: NICmsContentField.EFieldType.textarea,
            title: 'Title',
            required: true
        },
        {
            key: 'subtitle1',
            type: NICmsContentField.EFieldType.textarea,
            title: 'Subtitle 1'
        },
        {
            key: 'subtitle2',
            type: NICmsContentField.EFieldType.textarea,
            title: 'Subtitle 2'
        },
        <NICmsContentField.IRepeaterField>{
            key: 'goals',
            type: NICmsContentField.EFieldType.repeater,
            title: 'Goals',
            itemName: 'goal',
            itemNameField: 'currency',
            fields: [
                <NICmsContentField.IChoiceField>{
                    key: 'currency',
                    type: NICmsContentField.EFieldType.choice,
                    title: 'Currency',
                    options: () =>
                        (window['app'].multisite as MultisiteService).all.map(i => ({
                            key: i.currency,
                            title: `${i.name} - ${i.currency} (${i.currency_symbol})`
                        })),
                    required: true
                },
                <NICmsContentField.INumberField>{
                    key: 'goal',
                    type: NICmsContentField.EFieldType.number,
                    title: 'Goal',
                    required: true
                }
            ]
        }
    ]
})
@Component({
    selector: 'basket-total-modal',
    templateUrl: './basket-total-modal.component.html',
    standalone: true,
    imports: [ModalLayoutMiddleComponent, ICmsClientModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BasketTotalModalComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'blockContent'
    })
    content: NBasketTotalModal.IBlockDataContent;

    constructor(private modalRef: ModalRef<NBasketTotalModal.IBlockDataContent>) {
        super();
    }

    protected close(): void {
        this.modalRef.close();
    }
}
